<template>
    <div class="phonemes">
        <PaginatedResource ref="phonemesRes" :fetch-method="fetchPhonemes" :page-size="pageSize">
            <template #default="{ loading, resource, canLoadMore, loadMore }">
                <div class="phonemes__results">
                    <Spinner v-if="loading" />
                    <table class="phonemes__table control-table">
                        <thead class="control-table__head">
                            <tr class="control-table__row">
                                <th class="control-table__cell">Слово</th>
                                <th class="control-table__cell">Фонема</th>
                                <th class="control-table__cell" style="width: 100px">
                                    <PhonemesForm @saved="onSavedPhoneme" />
                                </th>
                            </tr>
                        </thead>
                        <tbody class="control-table__body">
                            <tr v-for="item in resource" :key="item.id" class="control-table__row">
                                <td class="control-table__cell">
                                    {{ item.key }}
                                </td>
                                <td class="control-table__cell">
                                    {{ item.value }}
                                </td>
                                <td class="control-table__cell">
                                    <Switcher
                                        :model-value="item.is_active"
                                        @update:model-value="changeActivity(item)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="canLoadMore" class="phonemes__loadmore">
                        <button
                            v-t="'misc.loadmore'"
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        />
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </div>
</template>

<script>
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import Switcher from '@speechki-frontend/shared/ui/Switcher/Switcher';
import PhonemesForm from '../PhonemesForm/PhonemesForm';
import { mapActions } from 'vuex';

import { adminFetchPhonemes, adminChangeActivity } from '../../api/phonemes';

export default {
    name: 'Phonemes',
    components: {
        PaginatedResource,
        Switcher,
        PhonemesForm
    },
    props: {
        languages: {
            type: Array,
            default: () => []
        },
        providers: {
            type: Array,
            default: () => []
        },
        pageSize: {
            type: Number,
            default: 10
        }
    },
    methods: {
        ...mapActions(['pushToast']),
        fetchPhonemes(params) {
            return adminFetchPhonemes(params);
        },
        async changeActivity({ id, is_active }) {
            try {
                await adminChangeActivity(id, !is_active);
            } catch (error) {
                this.pushToast({
                    type: 'error',
                    text: error.detail ? error.detail.join(', ') : 'Error occured'
                });
            }
        },
        onSavedPhoneme() {
            this.$refs.phonemesRes.fetch();
        }
    }
};
</script>

<style src="./Phonemes.scss" lang="scss"></style>
